import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { SearchResultComponent } from "../components/search-result/SearchResultComponent";
import { PublicController } from "../../ajax/PublicController";
import { debounce } from "../../helper/debounce";
import { SearchResultDTO } from "../../ajax/types/SearchResultDTO";

const MAX_RETURNED_RESULTS = 12;

export class IndexComponent implements IJSLComponent {

    private data: SearchResultDTO[];

    private term: string = "";

    private isLoading: boolean;
    private showAll: boolean;

    private searchDebounced = debounce(() => { this.showAll = false; this.search(); }, 200);

    public render(): IJSLVNode {
        return <section class="banner-area">

            <div class="container">
                <div style="text-align:right;margin-bottom:1rem;">
                    <a class="genric-btn primary search-btn" style="width:20rem;max-width:80vw" href="#detail" >
                        {this.isLoading ?
                            <span>...</span>
                            : //<i class="fa fa-filter"></i>
                            <span>zur Detail-Suche wechseln</span>
                        }
                    </a>
                </div>
                <div style="text-align:center">
                    <span style="margin-right:1rem;display:inline-block;">Pilztaxon oder Name:</span>
                    <input id="tb-search" type="text" style="max-width:80vw;text-align:left;width:20rem;" input={this.searchDebounced} />
                </div>
            </div>

            {/* <div class="container">

                <div class="row justify-content-between">
                    <div class="col-6 col-md-4">
                        <div style="text-align:right">Pilztaxon oder Name:</div>
                    </div>
                    <div class="col-8 col-md-6" style="text-align:right;">
                        <input id="tb-search" type="text" style="width:90%;text-align:left;" input={this.searchDebounced} />
                    </div>
                </div>
            </div> */}
            <div class="search-results row no-margin">
                {(this.data ?? []).map((d) => new SearchResultComponent(d))}
            </div>

            <div style="text-align:center;font-style:italic;font-size:1.5rem">{(this.data && this.data.length === 0 && this.term) ?
                <span>Keine Ergebnisse gefunden</span> : undefined}</div>
            <div>
                {!this.isLoading && this.data?.length === MAX_RETURNED_RESULTS ?
                    <p style="text-align:center"><button class="genric-btn primary" click={() => {
                        this.showAll = true;
                        this.search();
                    }}>mehr Ergebnisse</button></p> : null}
                {/* {this.data.length === MAX_RETURNED_RESULTS ?
                <p><i>* für weitere Ergebnisse bitte Namen vervollständigen</i></p> : null} */}
            </div>
        </section >;
    }

    public onCreate() {
        (document.getElementById("tb-search") as HTMLInputElement).value = this.term;
    }

    private search(): void {
        if (this.isLoading) {
            this.searchDebounced();
            return;
        }
        this.term = (document.getElementById("tb-search") as HTMLInputElement).value;
        if (!this.term) {
            this.data = null;
            refresh();
            return;
        }
        this.isLoading = true;
        PublicController.Search({ term: this.term, all: this.showAll }).then((data) => {
            this.data = data;
            this.isLoading = false;
            refresh();
        }).catch(() => {
            // error occured
            this.isLoading = false;
            this.searchDebounced();
        });
        refresh();
    }

}
